if (!customElements.get('bolt-cut-selects')) {
  customElements.define(
    'bolt-cut-selects',
    class BoltCutSelects extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.productFormId);
        this.variantInput = this.form?.querySelector('input[name="id"]');
        this.propertyInput = this.querySelector('[data-bolt-cut-property]');
        this.addEventListener('change', this.onCutChange.bind(this));
        this.syncFromChecked();

        if (this.form) {
          this.form.addEventListener('submit', this.onFormSubmit.bind(this));
        }
      }

      quantityInput() {
        const root =
          this.closest('.product__info-container') || this.closest('.product__info-wrapper') || document;
        return root.querySelector('input.quantity__input[name="quantity"]');
      }

      poolNeed(cut, quantity) {
        const qty = Number(quantity) || 0;

        if (cut === 'half-yard') {
          return qty * 2;
        }

        return qty;
      }

      syncQuantityMax(input) {
        const qtyInput = this.quantityInput();

        if (!qtyInput) return;

        const fqAvailRaw = this.dataset.fqAvailable;
        const fqAvail = Number(fqAvailRaw);
        const cut = input?.dataset.boltCut;
        const listed = Number(input?.dataset.inventory);
        let max = Number.isFinite(listed) ? listed : NaN;

        if (fqAvailRaw !== undefined && fqAvailRaw !== '' && Number.isFinite(fqAvail)) {
          const fromPool = cut === 'half-yard' ? Math.floor(fqAvail / 2) : fqAvail;
          max = Number.isFinite(max) ? Math.min(max, fromPool) : fromPool;
        }

        if (!Number.isFinite(max) || max < 0) return;

        qtyInput.max = String(max);
        qtyInput.dataset.max = String(max);

        const current = Number(qtyInput.value) || 1;

        if (current > max) {
          qtyInput.value = String(Math.max(max, 1));
        }
      }

      onFormSubmit(event) {
        const fqAvailRaw = this.dataset.fqAvailable;

        if (fqAvailRaw === undefined || fqAvailRaw === '') return;

        const fqAvail = Number(fqAvailRaw);
        const checked = this.querySelector('input[type="radio"]:checked');
        const qtyInput = this.quantityInput();
        const quantity = Number(qtyInput?.value) || 1;
        const need = this.poolNeed(checked?.dataset.boltCut, quantity);

        if (!Number.isFinite(fqAvail) || need <= fqAvail) return;

        event.preventDefault();
        event.stopPropagation();
      }

      onCutChange(event) {
        if (event.target.matches('input[type="radio"]')) {
          this.applyCut(event.target);
        }
      }

      syncFromChecked() {
        let checked = this.querySelector('input[type="radio"]:checked');

        if (!checked) {
          checked =
            this.querySelector('[data-bolt-cut="half-yard"]:not(.disabled)') ||
            this.querySelector('[data-bolt-cut="fat-quarter"]:not(.disabled)');

          if (checked) {
            checked.checked = true;
          }
        }

        if (checked) {
          this.applyCut(checked);
        }
      }

      applyCut(input) {
        const variantId = input.dataset.variantId;
        const price = input.dataset.price;

        if (this.variantInput && variantId) {
          this.variantInput.value = variantId;
          this.variantInput.disabled = false;
        }

        if (this.propertyInput) {
          if (input.dataset.synthetic === 'true' && input.dataset.cutLabel) {
            this.propertyInput.disabled = false;
            this.propertyInput.value = input.dataset.cutLabel;
          } else {
            this.propertyInput.disabled = true;
            this.propertyInput.value = '';
          }
        }

        const priceRoot = document.getElementById(`price-${this.dataset.section}`);

        this.syncQuantityMax(input);

        if (!priceRoot || !price) return;

        const amounts = priceRoot.querySelectorAll('.price-item__amount');

        if (amounts.length) {
          for (const el of amounts) {
            el.textContent = price;
          }
          return;
        }

        const regular = priceRoot.querySelector(
          '.price__regular .price-item--regular:not(.variant-item__old-price)'
        );
        const sale = priceRoot.querySelector('.price-item--sale');

        if (regular) regular.textContent = price;
        if (sale) sale.textContent = price;
      }
    }
  );
}
